import { c as _c } from "react/compiler-runtime";
/**
 * @description Безопасная обертка для компонента Image, предотвращающая ошибки с пустыми src
 * @example
 * <SafeImage src={imageUrl} alt="Image description" width={200} height={200} />
 *
 * @returns {JSX.Element | null}
 */

import Image, { type ImageProps } from 'next/image';
import type React from 'react';
import type { FC } from 'react';
interface SafeImageProps extends Omit<ImageProps, 'src'> {
  // Расширяем тип src, чтобы принимать различные типы, которые могут быть переданы в next/image
  src: string | null | undefined | {
    src: string;
    height: number;
    width: number;
  } | any;
  fallback?: React.ReactNode;
}
const SafeImage: FC<SafeImageProps> = t0 => {
  const $ = _c(9);
  let props;
  let src;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      src,
      fallback: t1,
      alt: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = src;
    $[3] = t1;
    $[4] = t2;
  } else {
    props = $[1];
    src = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const fallback = t1 === undefined ? null : t1;
  const alt = t2 === undefined ? "" : t2;
  if (!src) {
    return fallback as React.ReactNode;
  }
  if (typeof src === "string" && src === "") {
    return fallback as React.ReactNode;
  }
  if (typeof src === "object" && "src" in src && (!src.src || src.src === "")) {
    return fallback as React.ReactNode;
  }
  let t3;
  if ($[5] !== alt || $[6] !== props || $[7] !== src) {
    t3 = <Image src={src} alt={alt} {...props} />;
    $[5] = alt;
    $[6] = props;
    $[7] = src;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
SafeImage.displayName = 'SafeImage';
export default SafeImage;